declare global {
  interface Window {
    _env_?: {
      API_URL?: string;
    };
  }
}

const ENV = {
  // Resolution order:
  //  1. window._env_.API_URL -> runtime config from /config.js. The image ships an
  //     empty config.js; on OpenShift each namespace mounts its own value via a
  //     ConfigMap, so the SAME image can be promoted test -> prod without a rebuild.
  //  2. process.env.REACT_APP_API_URL -> inlined by CRA at build time (App Engine
  //     build + local .env).
  //  3. hardcoded fallback -> used only when neither of the above is set (e.g. the
  //     ConfigMap isn't mounted yet). NOTE: this is gbz's URL; if the SAME image runs
  //     in another namespace WITHOUT its own ConfigMap, it will talk to this backend.
  API_URL:
    window._env_?.API_URL ||
    process.env.REACT_APP_API_URL ||
    "https://ekranim-api-turkcellekranim-gbz.apps.gocpbmp1.tcs.turkcell.tgc",
};

export default ENV;
